var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenInNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "open_in_new"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2595_29019",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2595_29019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "open_in_new_2",
    d: "M3.53851 13.6666C3.20175 13.6666 2.91671 13.5499 2.68337 13.3166C2.45004 13.0832 2.33337 12.7982 2.33337 12.4614V3.53839C2.33337 3.20163 2.45004 2.91659 2.68337 2.68325C2.91671 2.44992 3.20175 2.33325 3.53851 2.33325H7.74359V3.33324H3.53851C3.48722 3.33324 3.4402 3.3546 3.39746 3.39734C3.35472 3.44008 3.33336 3.4871 3.33336 3.53839V12.4614C3.33336 12.5127 3.35472 12.5597 3.39746 12.6025C3.4402 12.6452 3.48722 12.6666 3.53851 12.6666H12.4615C12.5128 12.6666 12.5598 12.6452 12.6026 12.6025C12.6453 12.5597 12.6667 12.5127 12.6667 12.4614V8.25634H13.6667V12.4614C13.6667 12.7982 13.55 13.0832 13.3167 13.3166C13.0833 13.5499 12.7983 13.6666 12.4615 13.6666H3.53851ZM6.47951 10.223L5.77696 9.52042L11.9641 3.33324H9.33336V2.33325H13.6667V6.66657H12.6667V4.03579L6.47951 10.223Z",
    fill: "#155EEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/open_in_new.3970a1483d7bf8681a2309dfd7f22633.svg";
export { ForwardRef as ReactComponent };